import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../Layout';
import { showToast } from '../../helpers/customToast';
import { verifySalePayment } from '../../helpers/stripe';
import { getSaleOrderByDocumentId } from '../../helpers/saleOrder';
import { SaleCartManager } from '../../helpers/SaleCartManager';

const SalePaymentCompletePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const verificationAttempted = useRef(false);

    useEffect(() => {
        const verifyPayment = async () => {
            // Skip if verification was already attempted
            if (verificationAttempted.current) {
                return;
            }
            verificationAttempted.current = true;

            try {
                const documentId = searchParams.get('document_id');
                const sessionId = searchParams.get('session_id');

                if (!documentId || !sessionId) {
                    throw new Error('Missing required parameters');
                }

                console.log('Verifying sale payment for order:', documentId, 'session:', sessionId);

                // Get order details by documentId first
                const order = await getSaleOrderByDocumentId(documentId);
                if (!order) {
                    throw new Error('Order not found');
                }

                console.log('Found sale order:', order);

                // Verify payment status
                const paymentStatus = await verifySalePayment(sessionId, documentId);
                
                console.log('Sale payment status:', paymentStatus);
                
                if (paymentStatus.success) {
                    // Clear the cart
                    await SaleCartManager.clearCart();
                    
                    // Redirect to order confirmation
                    navigate('/vente/confirmation', {
                        state: { 
                            orderId: order.id,
                            documentId: documentId,
                            paymentConfirmed: true
                        }
                    });
                } else {
                    throw new Error('Payment verification failed');
                }
            } catch (error) {
                console.error('Sale payment verification error:', error);
                showToast('Une erreur est survenue lors de la vérification de votre paiement. Veuillez contacter le support.', 'error');
                navigate('/vente');
            } finally {
                setLoading(false);
            }
        };

        verifyPayment();
    }, [searchParams, navigate]);

    if (loading) {
        return (
            <Layout>
                <div className="container my-5">
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Vérification du paiement...</span>
                        </div>
                        <p className="mt-3">Vérification de votre paiement...</p>
                    </div>
                </div>
            </Layout>
        );
    }

    return null;
};

export default SalePaymentCompletePage;